<div class="modal-form container">
    <h2 class="jumbotron-heading text-center">{{title}}</h2>
    <mat-dialog-content class="mat-typography mat-mdc-dialog-content">
        <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

        <div class="edit">
            <form [formGroup]="userInfoForm">

                <div class="row">

                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>First Name</mat-label>
                            <input type="text" matInput formControlName="firstName" required>
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Last Name</mat-label>
                            <input type="text" matInput formControlName="lastName" required>
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Email</mat-label>
                            <input type="text" matInput formControlName="email" required placeholder="example@email.com">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="isCreateMode">
                        <mat-form-field appearance="outline" floatLabel="always" *ngIf="lgvUserSvc.IsAdmin"
                            class="readOnly">
                            <mat-label>Company</mat-label>
                            <mat-select formControlName="companyId" [disabled]="true">
                                <mat-option
                                    *ngFor="let comp of lgvApiSvc.Companies$ | async | sortBy:'asc':'displayOrder'"
                                    [value]="comp.id">
                                    {{comp.name}} - {{comp.companyCode}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="isCreateMode">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Organization</mat-label>
                            <input matInput placeholder="Select Organization" [matAutocomplete]="auto"
                                formControlName='organizationId'>
                            <mat-error *ngIf="userInfoForm.controls.organizationId.errors?.forbiddenObject">Please
                                select organization on the list</mat-error>
                        </mat-form-field>
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayOrg"
                            (optionSelected)="onOrganizationSelected($event.option.value)">
                            <mat-option *ngIf="isLoadingOrganization$ | async"><lgv-loading-indicator
                                    [CSSClass]="'Small'"></lgv-loading-indicator></mat-option>
                            <ng-container *ngIf="!(isLoadingOrganization$ | async)">
                                <mat-option *ngFor="let org of (filteredOrganization$ | async)" [value]="org">
                                    {{ org.name }}
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                    </div>
                    <div class="col-12" *ngIf="lgvUserSvc.IsAdmin && isCreateMode">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Role</mat-label>
                            <mat-select placeholder="Select all that apply" multiple formControlName="roles">
                                <mat-option *ngFor="let role of filteredRoles$ | async | sortBy:'asc':'displayOrder'"
                                    [value]="role.code">
                                    {{role.displayName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <ng-container *ngIf="!isCreateMode">

                    <div class="Vert-15"></div>
                    <div><b>Contact Information</b></div>
                    <div style="font-size:13px;">Information entered here will show up in your signature.</div>
                    <div class="Vert-10"></div>

                    <div class="row">
                        <div class="col-12">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>Address</mat-label>
                                <input type="text" matInput formControlName="address1">
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>City</mat-label>
                                <input type="text" matInput formControlName="city">
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>State</mat-label>
                                <input type="text" matInput formControlName="state">
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>Zip Code</mat-label>
                                <input type="number" matInput formControlName="zipCode">
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>Phone (work)</mat-label>
                                <input type="text" matInput formControlName="phone">
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>Phone (cell)</mat-label>
                                <input type="text" matInput formControlName="mobilePhone">
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>Fax</mat-label>
                                <input type="text" matInput formControlName="fax">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="Vert-15"></div>
                    <div><b>Employment Details</b></div>
                    <div class="Vert-10"></div>

                    <div class="row">
                        <div class="col-12">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>Job Title</mat-label>
                                <input type="text" matInput formControlName="jobTitle">
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="!(lgvUserSvc.isREAgent$| async)">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>NMLS ID</mat-label>
                                <input type="text" matInput formControlName="nmlsid">
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="(lgvUserSvc.isREAgent$| async)">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>License Number</mat-label>
                                <input type="text" matInput formControlName="licenseNumber">
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>Website</mat-label>
                                <input type="text" matInput formControlName="website">
                            </mat-form-field>
                        </div>

                        <!--Admin Only-->
                        <div *ngIf="lgvUserSvc.IsAdmin" class="col-12" style="background-color: gainsboro">

                            <div style="padding-top:15px; padding-bottom: 15px;"><b>Admin Only</b></div>

                            <div class="row">
                                <div class="col-12">
                                    <mat-form-field appearance="outline" floatLabel="always">
                                        <mat-label>Application Url</mat-label>
                                        <input type="text" matInput formControlName="applicationUrl">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <mat-form-field appearance="outline" floatLabel="always">
                                        <mat-label>OB Channel Index</mat-label>
                                        <input type="text" matInput formControlName="obchannelIndex">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <mat-form-field appearance="outline" floatLabel="always">
                                        <mat-label>OB Originator Index</mat-label>
                                        <input type="text" matInput formControlName="oboriginatorIndex">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <mat-form-field appearance="outline" floatLabel="always">
                                        <mat-label>Profile Image URL</mat-label>
                                        <input type="text" matInput formControlName="profileImageUrl">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="Vert-15"></div>

                    </div>
                </ng-container>

            </form>
        </div>


    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions" align="end">
        <button mat-stroked-button class="btn btn-secondary" (click)="onCancel()">
            Cancel
        </button>
        <button mat-stroked-button class="btn btn-primary" (click)="onSave()" [disabled]="!userInfoForm.valid">
            Save
        </button>
    </mat-dialog-actions>
</div>